// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ======================
   ReelAnalysisModal
   Two-column modal: video (left) + streaming AI breakdown (right).
   Uses CSS variables from colors.css.
   ====================== */

.ra-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.62);
  backdrop-filter: blur(3px);
  animation: ra-fade 0.15s ease;
}

.ra-content {
  position: fixed;
  z-index: 1001;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  width: min(960px, 94vw);
  height: min(640px, 88vh);
  background: var(--color-bg-root);
  border: 1px solid var(--color-border-input);
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.45);
  animation: ra-pop 0.16s ease;
}

@keyframes ra-fade {
  from { opacity: 0; }
}

@keyframes ra-pop {
  from { opacity: 0; transform: translate(-50%, -48%) scale(0.98); }
}

.ra-visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.ra-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 7px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-input);
  color: var(--color-text-secondary);
  cursor: pointer;
  flex-shrink: 0;
  transition: color 0.15s ease, border-color 0.15s ease;
}

.ra-close:hover {
  color: var(--color-text-primary);
  border-color: var(--color-text-secondary);
}

/* Left: video */
.ra-left {
  flex: 0 0 auto;
  width: 340px;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Top-right action cluster (Use in Composer · Open · Close) */
.ra-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.ra-use-composer {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 30px;
  padding: 0 13px;
  border: 1px solid var(--color-border-input);
  border-radius: 7px;
  background: var(--color-bg-canvas-surface);
  color: var(--color-text-primary);
  font-size: 12.5px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.ra-use-composer:hover {
  background: var(--color-bg-input);
  border-color: var(--color-text-secondary);
}

.ra-video {
  width: 100%;
  height: 100%;
  border: none;
  object-fit: contain;
  display: block;
  background: #000;
}

.ra-video--placeholder {
  background: #111;
}

/* Right: analysis */
.ra-right {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-width: 0;
  padding: 20px 22px 0;
}

.ra-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.ra-creator {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.ra-plat {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 7px;
  background: var(--color-bg-input);
  border: 1px solid var(--color-border-input);
  color: var(--color-text-primary);
  flex-shrink: 0;
}

.ra-username {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 15px;
  font-weight: 700;
  color: var(--color-text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ra-verified {
  color: #3897f0;
  flex-shrink: 0;
}

.ra-source {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 7px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-input);
  color: var(--color-text-secondary);
  text-decoration: none;
  flex-shrink: 0;
  transition: color 0.15s ease, border-color 0.15s ease;
}

.ra-source:hover {
  color: var(--color-text-primary);
  border-color: var(--color-text-secondary);
}

.ra-stats {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 12px;
}

.ra-stats span {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 12.5px;
  font-weight: 600;
  color: var(--color-text-secondary);
}

.ra-analysis-title {
  display: flex;
  align-items: center;
  gap: 7px;
  margin: 18px 0 4px;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.2px;
  color: var(--color-text-primary);
}

.ra-badge-ai {
  padding: 1px 7px;
  border-radius: 999px;
  background: linear-gradient(90deg, #7c3aed, #d6409f);
  color: #fff;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.5px;
}

.ra-analysis-body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 8px 4px 22px 0;
}

/* Streaming markdown */
.ra-markdown {
  font-size: 13.5px;
  line-height: 1.6;
  color: var(--color-text-primary);
}

.ra-markdown h2 {
  font-size: 14px;
  font-weight: 700;
  margin: 18px 0 6px;
  color: var(--color-text-primary);
}

.ra-markdown h2:first-child {
  margin-top: 2px;
}

.ra-markdown h1,
.ra-markdown h3 {
  font-size: 13.5px;
  font-weight: 700;
  margin: 14px 0 6px;
}

.ra-markdown p {
  margin: 0 0 10px;
  color: var(--color-text-secondary);
}

.ra-markdown ul,
.ra-markdown ol {
  margin: 0 0 10px;
  padding-left: 18px;
  color: var(--color-text-secondary);
}

.ra-markdown li {
  margin: 3px 0;
}

.ra-markdown strong {
  color: var(--color-text-primary);
  font-weight: 700;
}

.ra-markdown em {
  color: var(--color-text-secondary);
}

.ra-markdown code {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 12px;
  background: var(--color-bg-input);
  padding: 1px 5px;
  border-radius: 4px;
}

/* Blinking caret while streaming */
.ra-caret {
  display: inline-block;
  width: 7px;
  height: 14px;
  margin-left: 2px;
  vertical-align: text-bottom;
  background: var(--color-text-primary);
  animation: ra-blink 1s steps(2, start) infinite;
}

@keyframes ra-blink {
  to { visibility: hidden; }
}

/* Error */
.ra-error {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  padding: 16px 0;
  color: var(--color-text-secondary);
  font-size: 13px;
}

.ra-retry {
  padding: 7px 14px;
  border-radius: 6px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  font-size: 13px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
}

.ra-retry:hover {
  border-color: var(--color-text-secondary);
}

/* Skeleton */
.ra-skeleton {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.ra-skel-status {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12.5px;
  font-weight: 600;
  color: var(--color-text-secondary);
  margin-bottom: 2px;
}

.ra-skel-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #7c3aed;
  animation: ra-pulse 1s ease-in-out infinite;
}

@keyframes ra-pulse {
  0%, 100% { opacity: 0.35; transform: scale(0.85); }
  50% { opacity: 1; transform: scale(1.1); }
}

.ra-skel-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.ra-skel-heading,
.ra-skel-line {
  border-radius: 5px;
  background-color: var(--color-bg-input);
  background-image: linear-gradient(
    90deg,
    transparent 0%,
    rgba(127, 127, 127, 0.16) 50%,
    transparent 100%
  );
  background-size: 220% 100%;
  background-repeat: no-repeat;
  animation: ra-shimmer 1.3s ease-in-out infinite;
}

.ra-skel-heading {
  height: 13px;
  width: 42%;
}

.ra-skel-line {
  height: 10px;
}

.ra-skel-line--short {
  width: 60%;
}

@keyframes ra-shimmer {
  0% { background-position: 180% 0; }
  100% { background-position: -80% 0; }
}

/* Responsive: stack on narrow screens */
@media (max-width: 720px) {
  .ra-content {
    flex-direction: column;
    width: 96vw;
    height: 90vh;
  }
  .ra-left {
    width: 100%;
    height: 45%;
    flex: 0 0 auto;
  }
  .ra-right {
    padding: 16px 16px 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ReelAnalysisModal.css"],"names":[],"mappings":"AAAA;;;;2BAI2B;;AAE3B;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,+BAA+B;EAC/B,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,aAAa;EACb,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,uBAAuB;EACvB,wBAAwB;EACxB,gCAAgC;EAChC,2CAA2C;EAC3C,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;EAC3C,4BAA4B;AAC9B;;AAEA;EACE,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,OAAO,UAAU,EAAE,4CAA4C,EAAE;AACnE;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,iCAAiC;EACjC,kCAAkC;EAClC,eAAe;EACf,cAAc;EACd,qDAAqD;AACvD;;AAEA;EACE,gCAAgC;EAChC,yCAAyC;AAC3C;;AAEA,gBAAgB;AAChB;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,2CAA2C;EAC3C,kBAAkB;EAClB,0CAA0C;EAC1C,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,0DAA0D;AAC5D;;AAEA;EACE,iCAAiC;EACjC,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,2CAA2C;EAC3C,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,iCAAiC;EACjC,kCAAkC;EAClC,qBAAqB;EACrB,cAAc;EACd,qDAAqD;AACvD;;AAEA;EACE,gCAAgC;EAChC,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,oDAAoD;EACpD,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,uBAAuB;AACvB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,2DAA2D;EAC3D,eAAe;EACf,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,mCAAmC;AACnC;EACE,qBAAqB;EACrB,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,2BAA2B;EAC3B,qCAAqC;EACrC,+CAA+C;AACjD;;AAEA;EACE,KAAK,kBAAkB,EAAE;AAC3B;;AAEA,UAAU;AACV;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;EAC3C,iCAAiC;EACjC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,aAAa;AACb;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,WAAW,aAAa,EAAE,sBAAsB,EAAE;EAClD,MAAM,UAAU,EAAE,qBAAqB,EAAE;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;EAEE,kBAAkB;EAClB,uCAAuC;EACvC;;;;;GAKC;EACD,0BAA0B;EAC1B,4BAA4B;EAC5B,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,KAAK,2BAA2B,EAAE;EAClC,OAAO,2BAA2B,EAAE;AACtC;;AAEA,wCAAwC;AACxC;EACE;IACE,sBAAsB;IACtB,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;IACX,WAAW;IACX,cAAc;EAChB;EACA;IACE,oBAAoB;EACtB;AACF","sourcesContent":["/* ======================\n   ReelAnalysisModal\n   Two-column modal: video (left) + streaming AI breakdown (right).\n   Uses CSS variables from colors.css.\n   ====================== */\n\n.ra-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  background: rgba(0, 0, 0, 0.62);\n  backdrop-filter: blur(3px);\n  animation: ra-fade 0.15s ease;\n}\n\n.ra-content {\n  position: fixed;\n  z-index: 1001;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  display: flex;\n  width: min(960px, 94vw);\n  height: min(640px, 88vh);\n  background: var(--color-bg-root);\n  border: 1px solid var(--color-border-input);\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.45);\n  animation: ra-pop 0.16s ease;\n}\n\n@keyframes ra-fade {\n  from { opacity: 0; }\n}\n\n@keyframes ra-pop {\n  from { opacity: 0; transform: translate(-50%, -48%) scale(0.98); }\n}\n\n.ra-visually-hidden {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.ra-close {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  border-radius: 7px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-input);\n  color: var(--color-text-secondary);\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: color 0.15s ease, border-color 0.15s ease;\n}\n\n.ra-close:hover {\n  color: var(--color-text-primary);\n  border-color: var(--color-text-secondary);\n}\n\n/* Left: video */\n.ra-left {\n  flex: 0 0 auto;\n  width: 340px;\n  background: #000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Top-right action cluster (Use in Composer · Open · Close) */\n.ra-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.ra-use-composer {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 30px;\n  padding: 0 13px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 7px;\n  background: var(--color-bg-canvas-surface);\n  color: var(--color-text-primary);\n  font-size: 12.5px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n\n.ra-use-composer:hover {\n  background: var(--color-bg-input);\n  border-color: var(--color-text-secondary);\n}\n\n.ra-video {\n  width: 100%;\n  height: 100%;\n  border: none;\n  object-fit: contain;\n  display: block;\n  background: #000;\n}\n\n.ra-video--placeholder {\n  background: #111;\n}\n\n/* Right: analysis */\n.ra-right {\n  flex: 1 1 auto;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  padding: 20px 22px 0;\n}\n\n.ra-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.ra-creator {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n\n.ra-plat {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  border-radius: 7px;\n  background: var(--color-bg-input);\n  border: 1px solid var(--color-border-input);\n  color: var(--color-text-primary);\n  flex-shrink: 0;\n}\n\n.ra-username {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 15px;\n  font-weight: 700;\n  color: var(--color-text-primary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.ra-verified {\n  color: #3897f0;\n  flex-shrink: 0;\n}\n\n.ra-source {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  border-radius: 7px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-input);\n  color: var(--color-text-secondary);\n  text-decoration: none;\n  flex-shrink: 0;\n  transition: color 0.15s ease, border-color 0.15s ease;\n}\n\n.ra-source:hover {\n  color: var(--color-text-primary);\n  border-color: var(--color-text-secondary);\n}\n\n.ra-stats {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-top: 12px;\n}\n\n.ra-stats span {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 12.5px;\n  font-weight: 600;\n  color: var(--color-text-secondary);\n}\n\n.ra-analysis-title {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  margin: 18px 0 4px;\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: 0.2px;\n  color: var(--color-text-primary);\n}\n\n.ra-badge-ai {\n  padding: 1px 7px;\n  border-radius: 999px;\n  background: linear-gradient(90deg, #7c3aed, #d6409f);\n  color: #fff;\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.5px;\n}\n\n.ra-analysis-body {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 8px 4px 22px 0;\n}\n\n/* Streaming markdown */\n.ra-markdown {\n  font-size: 13.5px;\n  line-height: 1.6;\n  color: var(--color-text-primary);\n}\n\n.ra-markdown h2 {\n  font-size: 14px;\n  font-weight: 700;\n  margin: 18px 0 6px;\n  color: var(--color-text-primary);\n}\n\n.ra-markdown h2:first-child {\n  margin-top: 2px;\n}\n\n.ra-markdown h1,\n.ra-markdown h3 {\n  font-size: 13.5px;\n  font-weight: 700;\n  margin: 14px 0 6px;\n}\n\n.ra-markdown p {\n  margin: 0 0 10px;\n  color: var(--color-text-secondary);\n}\n\n.ra-markdown ul,\n.ra-markdown ol {\n  margin: 0 0 10px;\n  padding-left: 18px;\n  color: var(--color-text-secondary);\n}\n\n.ra-markdown li {\n  margin: 3px 0;\n}\n\n.ra-markdown strong {\n  color: var(--color-text-primary);\n  font-weight: 700;\n}\n\n.ra-markdown em {\n  color: var(--color-text-secondary);\n}\n\n.ra-markdown code {\n  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n  font-size: 12px;\n  background: var(--color-bg-input);\n  padding: 1px 5px;\n  border-radius: 4px;\n}\n\n/* Blinking caret while streaming */\n.ra-caret {\n  display: inline-block;\n  width: 7px;\n  height: 14px;\n  margin-left: 2px;\n  vertical-align: text-bottom;\n  background: var(--color-text-primary);\n  animation: ra-blink 1s steps(2, start) infinite;\n}\n\n@keyframes ra-blink {\n  to { visibility: hidden; }\n}\n\n/* Error */\n.ra-error {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 16px 0;\n  color: var(--color-text-secondary);\n  font-size: 13px;\n}\n\n.ra-retry {\n  padding: 7px 14px;\n  border-radius: 6px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  font-size: 13px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n}\n\n.ra-retry:hover {\n  border-color: var(--color-text-secondary);\n}\n\n/* Skeleton */\n.ra-skeleton {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.ra-skel-status {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12.5px;\n  font-weight: 600;\n  color: var(--color-text-secondary);\n  margin-bottom: 2px;\n}\n\n.ra-skel-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #7c3aed;\n  animation: ra-pulse 1s ease-in-out infinite;\n}\n\n@keyframes ra-pulse {\n  0%, 100% { opacity: 0.35; transform: scale(0.85); }\n  50% { opacity: 1; transform: scale(1.1); }\n}\n\n.ra-skel-section {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.ra-skel-heading,\n.ra-skel-line {\n  border-radius: 5px;\n  background-color: var(--color-bg-input);\n  background-image: linear-gradient(\n    90deg,\n    transparent 0%,\n    rgba(127, 127, 127, 0.16) 50%,\n    transparent 100%\n  );\n  background-size: 220% 100%;\n  background-repeat: no-repeat;\n  animation: ra-shimmer 1.3s ease-in-out infinite;\n}\n\n.ra-skel-heading {\n  height: 13px;\n  width: 42%;\n}\n\n.ra-skel-line {\n  height: 10px;\n}\n\n.ra-skel-line--short {\n  width: 60%;\n}\n\n@keyframes ra-shimmer {\n  0% { background-position: 180% 0; }\n  100% { background-position: -80% 0; }\n}\n\n/* Responsive: stack on narrow screens */\n@media (max-width: 720px) {\n  .ra-content {\n    flex-direction: column;\n    width: 96vw;\n    height: 90vh;\n  }\n  .ra-left {\n    width: 100%;\n    height: 45%;\n    flex: 0 0 auto;\n  }\n  .ra-right {\n    padding: 16px 16px 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
